import React from 'react'
import { Button } from 'reactstrap'
import useTranslation from '../hooks/UseTranslation'
import { toastPromise } from '../utils/toast'

const AsyncButton = ({
  onClick,
  children,
  toastId,
  disabled,
  success,
  error,
  loading,
  ...props
}) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = React.useState()
  const [randomId] = React.useState(toastId ?? Date.now())

  const _onClick = (e) => {
    if (isLoading) return
    setIsLoading(true)
    toastPromise(onClick(e), t, { toastId, success, error, loading })
      .catch(console.error)
      .finally(() => setIsLoading(false))
  }

  return (
    <Button disabled={disabled || isLoading} onClick={_onClick} {...props}>
      {children}
    </Button>
  )
}

export default AsyncButton
